function getDynamicConfig() {
    const { doxymeconfig } = window;
    return {
        ...doxymeconfig.frontend,
    };
}
export default getDynamicConfig;
